import styled from "styled-components";
import { Calendar, Card, Input, Select, TimePicker } from "antd";

export const btnCtnr = styled.button`
  border-radius: 6px;
  padding-bottom: "3%";
  -webkit-appearance: button;
  font-weight: 400;
`;

export const rowC = styled.div`
  display: flex;
  flex-direction: row;
  float: left;
`;

export const XCalendar = styled(Calendar)`
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  .ant-picker-panel .ant-picker-body {
    padding: 0px 0 !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-today
    .ant-picker-cell-inner::before {
    border: none;
  }
  .ant-picker-cell-today {
    background-color: #A971D4;
  }
  .ant-picker-cell-selected {
    background-color: #d1bed4;
  }
  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    background: transparent;
    color: #fff;
    align-items: center;
    padding-top: 5%;
    border-bottom-style: hidden;
    border-top: 0px !important;
  }
  .ant-picker-cell-in-view .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    border-top: 0px !important;
  }
  .ant-picker-cell .ant-picker-cell-start,
  .ant-picker-cell-inner.ant-picker-calendar-date {
    border-top: 0px !important;
  }

  .ant-picker-cell-in-view.ant-picker-cell-today
    .ant-picker-cell-inner::before {
    border: none;
  }

  .ant-picker-content td > .ant-picker-cell .ant-picker-cell-inner {
    border-top: 0px !important;
  }

  .ant-picker-content td {
    border: 1px solid #cdcdcd54;
    text-align: left;
    padding: 0 0px 5px 12px !important;
  }
  .ant-picker-cell:hover:not(.ant-picker-cell-in-view) .ant-picker-cell-inner,
  .ant-picker-cell:hover:not(.ant-picker-cell-selected):not(
      .ant-picker-cell-range-start
    ):not(.ant-picker-cell-range-end):not(
      .ant-picker-cell-range-hover-start
    ):not(.ant-picker-cell-range-hover-end)
    .ant-picker-cell-inner {
    background: transparent;
  }

  .ant-picker-content th {
    border: 1px solid #cdcdcd54;
    font-weight: 400;
    text-align: left;
    padding: 0 0px 5px 24px !important;
    height: 63px !important;
  }

  .ant-picker-content th:nth-child(1) {
    font-weight: 600;
  }

  .ant-picker-content th:nth-child(7) {
    // color: red;
    font-weight: 600;
  }

  .ant-picker-content th:nth-child(2) {
    font-weight: 600;
  }
  .ant-picker-content th:nth-child(3) {
    font-weight: 600;
  }
  .ant-picker-content th:nth-child(4) {
    font-weight: 600;
  }
  .ant-picker-content th:nth-child(5) {
    font-weight: 600;
  }
  .ant-picker-content th:nth-child(6) {
    font-weight: 600;
  }

  // Radio
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #fff;
    background: #883da9; 
  }
  .ant-radio-button-wrapper {
    color: #883da9;
    /* border-radius:0px 7px 7px 0px; */
  }
  .ant-radio-button-wrapper:first-child {
    border-radius: 7px 0px 0px 7px;
  }
  .ant-radio-button-wrapper:last-child {
    border-radius: 0px 7px 7px 0px;
  }
  @media (max-width: 476px) {
    .ant-picker-content th {
      border: 1px solid #cdcdcd54;
      font-weight: 400;
      text-align: left;
      padding: 5px !important;
      text-align: center;
      height: auto !important;
    }
    .ant-picker-content td {
      border: 1px solid #cdcdcd54;
      text-align: center;
      padding: 5px !important;
      height: auto !important;
    }
    .ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date {
      padding: 0px;
    }
    .ant-picker-calendar-date-content {
      height: auto !important;
    }
  }
  @media (max-width: 281px) {
    .ant-picker-content th {
      border: 1px solid #cdcdcd54;
      font-weight: 400;
      text-align: left;
      padding: 1px !important;
      text-align: center;
      height: auto !important;
      font-size: 10px;
      width: auto;
    }
    .ant-picker-content td {
      border: 1px solid #cdcdcd54;
      text-align: center;
      padding: 1px !important;
      height: auto !important;
      padding: 0px !important;
      font-size: 10px;
      overflow: hidden;
    }
    .ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date {
      padding: 0px !important;
    }
    .ant-picker-calendar-date-content {
      height: auto !important;
      padding: 0px !important;
    }
    .ant-picker-content table {
      width: 100%;
      position: relative;
    }
  }
`;

export const SlotView = styled(Card)`
  border-radius: 10px;
  justify-content: space-between;
  .ant-card-body {
    padding: 8px 8px 8px 8px;
    padding: 8px 8px 8px 8px;
    width: 204px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  @media (max-width: 281px) {
    .ant-card-body {
      width: 100% !important;
    }
  }
`;
export const SlotViewDelete = styled.div`
  cursor: pointer;
  position: relative;
  right: -4px;
  font-size: 14px;
  color: #eb2f96;
  margin-top: -6px;
`;
export const AddSlotButton = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 7px;
`;
export const DayButton = styled.div`
  text-transform: uppercase;
  border: 1px solid #f0f0f0;
  border-radius: 50px;
  width: 60px;
  height: 60px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: flex-start;
  justify-content: center;
  align-items: center;
  background: #f1f4fe;
  color: #3a3e4d;
  font-weight: 600;
`;
export const TimeSlotDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: center;
  align-items: center;
  margin-top: 26px;
`;
export const TimeSlotCard = styled(Card)`
  width: 100%;
  border-color: transparent;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`;
export const DaySlotDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: center;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  .selected {
    background: ${(props) => props.theme.colors.primary};
    color: #fff;
    box-shadow: 0px 3px 5px 2px rgba(0, 0, 0, 0.1);
  }
`;
export const TimePickerBox = styled(TimePicker)`
  border-radius: 7px !important;
  height: 40px;
  input {
    font-size: 14px !important;
  }
`;
export const SelectBox = styled(Select)`
  font-size: 14px;
  div.ant-select-selector {
    border-radius: 7px !important;
  }
`;
// export const DayButton = styled(Select)`
//     font-size:14px;
//     div.ant-select-selector{
//         border-radius:7px !important;
//     }
// `;
